var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"presentation-img",style:({
    backgroundImage: ("url(" + (_vm.slide.preview ? _vm.slide.preview.thumb.url : '') + ")"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }